import { Form, Input, InputNumber, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function RoomForm({ form, onSubmit, schools }) {
    const { loading } = useSelector((state) => state?.rooms);
    const { t } = useTranslation();
    return (
        <Form
            layout="vertical"
            name="room_form"
            id="room_form"
            form={form}
            onFinish={onSubmit}
            disabled={loading}
            style={{
                maxWidth: 600,
                margin: "0 auto",
            }}
        >
            <Form.Item
                label={t("rooms.crud.form.label.school")}
                name="schoolId"
                rules={[
                    {
                        required: true,
                        message: t(
                            "rooms.crud.form.error.label.required.school"
                        ),
                    },
                ]}
            >
                <Select>
                    {schools?.map((school) => (
                        <Select.Option key={school?._id} value={school?._id}>
                            {school?.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item
                label={t("rooms.crud.form.label.name")}
                name="titled"
                rules={[
                    {
                        required: true,
                        message: t("rooms.crud.form.error.label.required.name"),
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label={t("rooms.crud.form.label.type")}
                name="salleType"
                rules={[
                    {
                        required: true,
                        message: t("rooms.crud.form.error.label.required.type"),
                    },
                ]}
            >
                <Select>
                    {["Available", "Not Available"]?.map((status) => (
                        <Select.Option key={status} value={status}>
                            {status}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item
                label={t("rooms.crud.form.label.capacity")}
                name="ability"
                rules={[
                    {
                        required: true,
                        message: t(
                            "rooms.crud.form.error.label.required.capacity"
                        ),
                    },
                ]}
            >
                <InputNumber min={1} />
            </Form.Item>
        </Form>
    );
}
